import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  text: {
    color: theme.palette.primary.light,

    '&.MuiTypography-root': {
      fontSize: theme.spacing(1.75),
    },
  },

  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },

  button: {
    width: '100%',

    '&.MuiButton-root': {
      fontWeight: 'bold',
      textTransform: 'capitalize',
    },
  },

  forfeit: {
    '&.MuiButton-root': {
      color: theme.palette.text.primary,
      marginBottom: theme.spacing(2),
      border: `${theme.spacing(0.125)} solid ${theme.palette.error.light}`,

      '&:hover': {
        border: `${theme.spacing(0.125)} solid ${theme.palette.error.light}`,
        backgroundColor: theme.palette.error.light,
      },
    },
  },
}));
